import { Language } from "../languages/labels/language.labels";

export function legalFormList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'sarl', display: lang.labels.legalFormSarl },
    { code: 'sa', display: lang.labels.legalFormSa },
    { code: 'ri', display: lang.labels.legalFormRi },
    { code: 'snc', display: lang.labels.legalFormSnc },
    { code: 'cooperative', display: lang.labels.legalFormCooperative },
    { code: 'association', display: lang.labels.legalFormAssociation },
    { code: 'fondation', display: lang.labels.legalFormFondation },
    { code: 'autre', display: lang.labels.legalFormAutre },
  ]
}

export function legalFormValue(lang: Language, code: string): string {
  let item = legalFormList(lang).find((item) => (item.code === code))
  return item ? item.display : ''
}
